<template>
  <section class="section container pt-0">
    <vehicle-datatable />
  </section>
</template>

<script>
import VehicleDatatable from "./vehicle_datatable/Index.vue";

export default {
  name: "TripVehicles",
  components: {
    VehicleDatatable,
  },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
